<template>
  <div class="ine-form__additional-links">
    <a
      class="ine-form__additional-link"
      target="_blank"
      rel="noopener"
      :href="`//${plansLink}`"
      >{{ plansLabel }}</a
    >
    <a
      class="ine-form__additional-link"
      target="_blank"
      rel="noopener"
      :href="`//ine.com`"
      >INE.com</a
    >
    <a
      class="ine-form__additional-link"
      target="_blank"
      rel="noopener"
      :href="`//community.ine.com`"
      >INE Community</a
    >
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'AdditionalLinks',
  props: {
    isTabletFooter: {
      type: Boolean,
      required: false,
      default() {
        return false
      },
    },
  },
  computed: {
    ...mapState({
      plansLink: state => state.app.plansLink,
    }),
    plansLabel() {
      return this.isTabletFooter ? 'Our plans' : 'Learn More About Our Plans'
    },
    checkoutUrl() {
      return process.env.VUE_APP_CHECKOUT_URL
    },
  },
}
</script>
